import React from 'react';
import { element, string } from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  display: inline-block;
  z-index: 1;

`;
const TipContainer = styled.div`
  position: absolute;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.30);
  padding: 15px;
  ${({ anchor, }) => anchor === 'left' && 'left: 0;'}
  ${({ anchor, }) => anchor === 'right' && 'right: 0;'}
`;

export class Tooltip extends React.Component {
  static propTypes = {
    children: element.isRequired,
    anchor: string.isRequired
  }
  state = {
    active: false,
  }
  toggleTip = () => {
    this.setState({
      active: !this.state.active,
    });
  }
  hideTip = () => {
    this.setState({ active: false, });
  }
  showTip = () => {
    this.setState({ active: true, });
  }
  mouseLeave = () => {
    if (this.state.active) {
      setTimeout(() => {
        this.hideTip();
      }, 1200);
    }
  }
  render() {
    const { children, anchor } = this.props;
    return (
      <Container
        onMouseLeave={ this.mouseLeave }
      >
        <i
          className="fa fa-question-circle"
          style={ {
            marginLeft: 5,
            cursor: 'pointer',
          } }
          onClick={ this.toggleTip }
          aria-hidden="true"
        />
        {
          this.state.active &&
          <TipContainer anchor={ anchor }>
            { children }
          </TipContainer>
        }
      </Container>
    );
  }
}

// export const Tooltip = ({ children }) => (
//   <Container>
//     <i
//       className="fa fa-question-circle"
//       style={ {
//         marginLeft: 5
//       } }
//       aria-hidden="true"
//     />
//     <TipContainer>
//       { children }
//     </TipContainer>
//     <Popover
//       open={open}
//       anchorEl={this.anchorEl}
//       anchorReference={anchorReference}
//       anchorPosition={{ top: positionTop, left: positionLeft }}
//       onClose={this.handleClose}
//       anchorOrigin={{
//         vertical: anchorOriginVertical,
//         horizontal: anchorOriginHorizontal,
//       }}
//       transformOrigin={{
//         vertical: transformOriginVertical,
//         horizontal: transformOriginHorizontal,
//       }}
//     >
//       <Typography className={classes.typography}>The content of the Popover.</Typography>
//     </Popover>
//   </Container>
// );

// Tooltip.propTypes = PropTypes;
// Tooltip.defaultProps = DefaultProps;

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/Tooltip/index.js